/* Same-day cutoff countdown for the TOP BAR — FlowerDeliveryDubai.

   ⚠️ NOTE: the store also has a separate dismissible urgency strip under the
   header whose element already uses the class .fdd-cd. This script therefore
   uses .fdd-topcd for its own span so the two never collide. If you only want
   one countdown on the page, delete the <script src="fdd-countdown.js"> line
   from layout/theme.liquid — the top bar then falls back to its static
   sentence and the strip under the header remains the single countdown.

   Dubai is UTC+4 all year (no daylight saving), so the cutoff is computed in
   Dubai time no matter where the visitor is. Shop hours are 9:00–22:00 and
   22:00 is the real same-day cutoff — both already published on the site.

   Shopify sanitises the top-bar 'text1' setting and strips class/id
   attributes, so there is no marker to hook onto. Instead this finds the first
   text node inside .hdt-top-bar__text .hdt-rte and swaps it for a span it
   creates client-side, leaving the 'Shop now' link untouched. The static
   sentence in header-group.json is true on its own, so the bar still reads
   correctly if this script never runs.

   The message is shortened under 480px so it does not push the bar to three
   lines on a phone. */
(function () {
  var DUBAI_OFFSET_MIN = 240;
  var CLS = 'fdd-topcd';

  function dubaiNow() {
    var n = new Date();
    return new Date(n.getTime() + n.getTimezoneOffset() * 60000 + DUBAI_OFFSET_MIN * 60000);
  }

  function message() {
    var narrow = window.innerWidth < 480;
    var d = dubaiNow();
    var opens = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 9, 0, 0, 0);
    var cutoff = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 22, 0, 0, 0);

    if (d < opens || d >= cutoff) {
      return narrow ? 'Same-day delivery resumes at 9 AM'
                    : 'Same-day delivery resumes at 9 AM — order now for tomorrow';
    }
    var ms = cutoff - d;
    var h = Math.floor(ms / 3600000);
    var m = Math.floor((ms % 3600000) / 60000);
    var s = Math.floor((ms % 60000) / 1000);

    if (narrow) {
      return 'Order within ' + (h > 0 ? h + 'h ' : '') + m + 'm for same-day delivery';
    }
    return 'Order in the next ' + (h > 0 ? h + 'h ' : '') + m + 'm ' + s + 's for same-day delivery in Dubai';
  }

  function slots() {
    var out = [];
    var wraps = document.querySelectorAll('.hdt-top-bar__text .hdt-rte');
    for (var i = 0; i < wraps.length; i++) {
      var w = wraps[i];
      var span = w.querySelector('.' + CLS);
      if (!span) {
        var node = null;
        for (var j = 0; j < w.childNodes.length; j++) {
          var n = w.childNodes[j];
          if (n.nodeType === 3 && n.nodeValue && n.nodeValue.replace(/\s/g, '')) { node = n; break; }
        }
        if (!node) { continue; }
        span = document.createElement('span');
        span.className = CLS;
        node.parentNode.replaceChild(span, node);
      }
      out.push(span);
    }
    return out;
  }

  function render() {
    var els = slots();
    if (!els.length) { return; }
    var msg = message() + ' ';
    for (var i = 0; i < els.length; i++) {
      if (els[i].textContent !== msg) { els[i].textContent = msg; }
    }
  }

  function start() {
    render();
    setInterval(render, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();